import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {RouteService} from '../../shared/services/route.service';
import {FormGroup, FormControl, FormArray, Validators} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {Discount, DiscountUpdate, DiscountCreate} from '../../shared/models/discount.model';

import swal from 'sweetalert2';
import {NgbDate, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'form-discount',
    templateUrl: 'form-discount.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormDiscountComponent implements OnInit, OnDestroy {

    @Input() discounts: Discount[];

    discountForm: FormGroup;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private routeService: RouteService,
                private dataStorageService: DataStorageService,
                private ngDateParserFormatter: NgbDateParserFormatter) {
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        const discounts = new FormArray([]);
        if (this.discounts) {
            for (const discount of this.discounts) {
                const start_date = new NgbDate(
                    +discount.start.substring(0, 4),
                    +discount.start.substring(5, 7),
                    +discount.start.substring(8, 10));
                const end_date = new NgbDate(
                    +discount.end.substring(0, 4),
                    +discount.end.substring(5, 7),
                    +discount.end.substring(8, 10));
                const start_date_issue = new NgbDate(
                    +discount.start_issue.substring(0, 4),
                    +discount.start_issue.substring(5, 7),
                    +discount.start_issue.substring(8, 10));
                const end_date_issue = new NgbDate(
                    +discount.end_issue.substring(0, 4),
                    +discount.end_issue.substring(5, 7),
                    +discount.end_issue.substring(8, 10));
                discounts.push(
                    new FormGroup({
                        'id': new FormControl(discount.id, Validators.required),
                        'title': new FormControl(discount.title, Validators.required),
                        'type': new FormControl(discount.type, Validators.required),
                        'code': new FormControl(discount.code, Validators.required),
                        'amount': new FormControl(discount.amount, Validators.required),
                        'start': new FormControl(start_date, Validators.required),
                        'end': new FormControl(end_date, Validators.required),
                        'start_issue': new FormControl(start_date_issue, Validators.required),
                        'end_issue': new FormControl(end_date_issue, Validators.required)
                    })
                );
            }
        }
        this.discountForm = new FormGroup({
            'discounts': discounts
        });


    }

    getControls() {
        return (<FormArray>this.discountForm.get('discounts')).controls;
    }

    onAddDiscount() {
        (<FormArray>this.discountForm.get('discounts')).push(
            new FormGroup({
                'id': new FormControl(),
                'title': new FormControl(null, Validators.required),
                'type': new FormControl('Promo'),
                'code': new FormControl(null, Validators.required),
                'amount': new FormControl(null, Validators.required),
                'start': new FormControl(null, Validators.required),
                'end': new FormControl(null, Validators.required),
                'start_issue': new FormControl(null, Validators.required),
                'end_issue': new FormControl(null, Validators.required)
            })
        );
    }

    onSubmitDiscount(index: number) {
        const discountValue = (<FormArray>this.discountForm.get('discounts')).at(index).value;
        const start_date_raw = discountValue.start;
        const end_date_raw = discountValue.end;
        const start_issue_date_raw = discountValue.start_issue;
        const end_issue_date_raw = discountValue.end_issue;
        const start_date = this.ngDateParserFormatter.format(start_date_raw);
        const end_date = this.ngDateParserFormatter.format(end_date_raw);
        const start_issue_date = this.ngDateParserFormatter.format(start_issue_date_raw);
        const end_issue_date = this.ngDateParserFormatter.format(end_issue_date_raw);
        if (discountValue.id) {
            // update
            const newDiscount = new DiscountUpdate(discountValue.id, discountValue.title, discountValue.type
                , discountValue.code, discountValue.amount, start_date, end_date, start_issue_date, end_issue_date);
            this.dataStorageService.updateDiscount(newDiscount)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                    if (responseData['error']) {
                    } else {
                        swal(
                            'Good job!', 'You updated discount coupon!', 'success'
                        );
                        location.reload();
                    }
                }
            );
        } else {
            // create
            const newDiscount = new DiscountCreate(discountValue.title, discountValue.type
                , discountValue.code, discountValue.amount, start_date, end_date, start_issue_date, end_issue_date);
            this.dataStorageService.createDiscount(newDiscount)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                    if (responseData['error']) {
                        console.log('creating discount error');
                    } else {
                        swal(
                            'Good job!', 'You created new discount coupon!', 'success'
                        );
                        location.reload();
                    }
                }
            );
        }
    }

    onDeleteDiscount(index: number) {
        const discountValue = (<FormArray>this.discountForm.get('discounts')).at(index).value;
        if (discountValue.id) {
            swal({
                title: 'Are you sure?',
                text: 'This can cause problem if some customer already used it!',
                showCancelButton: true,
                confirmButtonColor: '#2dce89',
                cancelButtonColor: '#f5365c',
                confirmButtonText: 'Yes, Proceed',
                cancelButtonText: 'No, cancel!'
            }).then((result) => {
                if (result.value) {
                    this.dataStorageService.deleteDiscount(discountValue.id)
                        .pipe(takeUntil(this.unsubscribe$)).subscribe(
                            responseData => {
                                if (responseData['error']) {
                                    console.log('deleting discount error');
                                } else {
                                    swal(
                                        'Good job!', 'You deleted discount coupon!', 'success'
                                    );
                                    location.reload();
                                }
                            }
                        );
                }
            });
        } else {
            (<FormArray>this.discountForm.get('discounts')).removeAt(index);
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
